export var SHOPGATE_CHECKOUT_GET_URL='shopgate.checkout.getUrl';